import { useAuth } from "@/AuthContext";

// Correspondance chemins frontend admin → module du centre de permissions (préfixe le plus long gagne)
export const ADMIN_PATH_MODULES = [
  ["/admin/widgets", "dashboard"],
  ["/admin/entreprises", "clients"], ["/admin/syndicats", "clients"], ["/admin/associations", "clients"],
  ["/admin/inscriptions", "commercial"], ["/admin/promotions", "commercial"],
  ["/admin/cancellations", "finance"], ["/admin/paypal", "finance"], ["/admin/billing", "finance"], ["/admin/stripe-connect", "finance"], ["/admin/stripe", "finance"],
  ["/admin/baremes", "reglementaire"],
  ["/admin/recrutement", "recrutement"], ["/admin/business-partners", "recrutement"],
  ["/admin/automations", "technique"], ["/admin/incidents", "technique"], ["/admin/integrations", "technique"], ["/admin/health", "technique"], ["/admin/studio", "marketplace"], ["/admin/marketplace", "marketplace"], ["/admin/billetterie", "billetterie"], ["/admin/metiers", "technique"],
  ["/admin/emails", "communication"], ["/admin/notifications", "communication"], ["/admin/twilio", "communication"],
  ["/admin/sendgrid", "communication"], ["/admin/i18n", "communication"],
  ["/admin/support", "support"], ["/admin/announcements", "support"], ["/admin/formations", "support"], ["/admin/testimonials", "support"], ["/admin/legal", "support"],
  ["/admin/audit", "securite"], ["/admin/2fa", "securite"], ["/admin/secure-connect", "securite"],
  ["/admin/team", "equipe"],
  ["/admin", "dashboard"],
];

export function moduleForAdminPath(pathname) {
  let best = null;
  for (const [prefix, mod] of ADMIN_PATH_MODULES) {
    if (pathname === prefix || pathname.startsWith(prefix + "/") || (prefix === "/admin" && pathname === "/admin")) {
      if (!best || prefix.length > best[0].length) best = [prefix, mod];
    }
  }
  return best ? best[1] : "dashboard";
}

export function usePerms() {
  const { user } = useAuth();
  const isPrincipal = user?.role === "admin";
  const isStaff = user?.role === "staff";
  const can = (module, action = "voir") => {
    if (isPrincipal) return true;
    if (!isStaff) return false;
    if (module === "equipe") return false;
    return ((user.permissions || {})[module] || []).includes(action);
  };
  return { user, isPrincipal, isStaff, can, canPath: (pathname, action = "voir") => can(moduleForAdminPath(pathname), action) };
}
